module.exports = __webpack_public_path__ + "static/media/srodowiskowe.1afb5f37.jpg";